// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { Target } from '../../client';
import BasketCombinationsSliderCell, {
  type BasketCombinationsSliderCellDataType,
} from '../BasketCombinationsSliderCell';
import ScrollView from '../ScrollView';

const Wrap = styled.div`
  margin: 0.25em 0;
  cursor: pointer;
  overflow: hidden;
  user-select: none;
  -webktip-tap-highlight-color: transparent;
`;

const InnerWrap = styled.div`
  display: inline-block;
  position: relative;
  height: 100%;
  overflow: hidden;
`;

const List = styled.div`
  padding: 0 1.5em 0 0;
  position: relative;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-style: preserve-3d;
`;

const StyledCell = styled(BasketCombinationsSliderCell)`
  display: flex;
  flex-direction: row;
  height: 1.8em;

  &&&& {
    margin: 0em 0.33em;
    width: ${Target.__MOBILE__ ? '100%' : 'calc(100% - 2em)'};
  }
`;

type BasketCombinationsSliderProps = {
  combinations: Array<BasketCombinationsSliderCellDataType>;
  className?: string;
};

const BasketCombinationsSlider = ({ combinations = [], className }: BasketCombinationsSliderProps) => {
  const Combinations = useMemo(
    () =>
      combinations.map<unknown>(({ label, counter }, i) => (
        <StyledCell key={`combination-cell-${i}`} label={label} counter={counter} />
      )),
    [combinations],
  );

  return (
    <Wrap className={className}>
      <ScrollView vertical={false}>
        <InnerWrap>
          <List>{Combinations}</List>
        </InnerWrap>
      </ScrollView>
    </Wrap>
  );
};

export default BasketCombinationsSlider;
